import { ConfigProvider, Button, Input, message } from "antd";
import styles from "./BetaLaunch.module.css";
import { Helmet } from "react-helmet";
import { useState } from "react";
import { useAccount } from "@vojomo-core/shared";

export function BetaLaunch(): React.ReactElement {
  const [email, setEmail] = useState("");
  const [googleUser, setGoogleUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const { login } = useAccount();

  const iconUrl = new URL(
    `../../../../shared/src/static/Vojomo_Horiz_fullcolor_rgb.png`,
    import.meta.url
  ).href;

  const handleSignup = async (): Promise<void> => {
    if (!email) {
      message.error("Please enter your email address");
      return;
    }

    setLoading(true);

    try {
      // Use fetch directly to avoid sending auth credentials
      const baseUrl = import.meta.env.VITE_REACT_APP_SERVER;
      const url = `${baseUrl}/beta/signup_by_email?email=${encodeURIComponent(email)}&google_user=${googleUser}`;

      const res = await fetch(url, {
        method: "POST",
        credentials: "omit" // Don't send cookies/auth
      });

      const response: {
        message: string;
        color: string;
        success: boolean;
      } = await res.json();

      if (response.success) {
        message.success(response.message);
        setEmail("");
        setGoogleUser(false);
        setShowForm(false);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Beta Launch - Vojomo</title>
      </Helmet>
      <div className={styles.body}>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                defaultBorderColor: "rgb(44, 21, 97)",
                defaultHoverBorderColor: "rgb(64, 41, 117)",
                defaultBg: "rgb(44, 21, 97)",
                defaultHoverBg: "rgb(64, 41, 117)"
              }
            }
          }}
        >
          {/* Header with Logo and Buttons */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingLeft: "40px",
              paddingRight: "40px",
              paddingTop: "20px"
            }}
          >
            <img
              src={iconUrl}
              alt="Vojomo Logo"
              style={{
                width: "180px"
              }}
            />
            <div style={{ position: "relative" }}>
              <div>
                <Button
                  size="large"
                  style={{
                    color: "white",
                    fontWeight: "500",
                    marginRight: "10px"
                  }}
                  onClick={() => setShowForm(true)}
                >
                  Sign Up
                </Button>
                <Button
                  size="large"
                  style={{
                    color: "white",
                    fontWeight: "500"
                  }}
                  onClick={() => {
                    login(true);
                  }}
                >
                  Login
                </Button>
              </div>
              {showForm && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    right: 0,
                    marginTop: "8px",
                    backgroundColor: "white",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    minWidth: "300px",
                    zIndex: 1000
                  }}
                >
                  <h4 style={{ marginTop: 0, marginBottom: "12px" }}>
                    Sign Up For Access
                  </h4>
                  <Input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{ marginBottom: "12px" }}
                    onPressEnter={handleSignup}
                  />
                  <p className="mt-0 mb-2 text-xs">
                    Please enter the email where you recieved the invitation
                    (we'll send you a link or connect you via Google, depending
                    on your email provider).
                  </p>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <Button
                      type="primary"
                      onClick={handleSignup}
                      loading={loading}
                      style={{
                        flex: 1,
                        backgroundColor: "rgb(44, 21, 97)",
                        borderColor: "rgb(44, 21, 97)"
                      }}
                    >
                      Submit
                    </Button>
                    <Button
                      onClick={() => setShowForm(false)}
                      style={{ flex: 1, color: "white" }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div
            className="flex items-center justify-center"
            style={
              {
                // padding: "40px 0px 40px 20px",
              }
            }
          >
            <div className="text-center max-w-4xl">
              <p
                className="text-[28px] font-bold mb-8"
                style={{ color: "#2c1561" }}
              >
                You're Invited to Vojomo Beta
              </p>
              <p
                className="text-[24px] mb-8 text-left"
                style={{ color: "#586B8F" }}
              >
                Help us build an AI platform that helps teams like yours find
                clarity and alignment on what matters most. Get started by
                clicking "Sign Up" and entering your email above.
              </p>
              <div className={styles.videoContainer}>
                <div className={styles.videoWrapper}>
                  {/* Replace the src with your actual video URL */}
                  <iframe
                    src="https://share.descript.com/embed/gnQh8ALPf3i"
                    title="Vojomo Beta Launch Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className={styles.video}
                  ></iframe>
                </div>
              </div>
              <p
                className="text-[18px] mt-12 mb-8 text-left"
                style={{ color: "#586B8F" }}
              >
                <strong>The Mission:</strong> Help teams create clarity, build
                genuine consensus, and maintain alignment on their most
                important priorities. <br />
                <strong>Your Role:</strong> Try it. Tell us what works and what
                doesn't.
                <br />
                <strong>Feedback:</strong> Feedback button (in platform) or
                feedback@vojomo.com
              </p>
            </div>
          </div>
          <div
            style={{
              justifyContent: "center",
              display: "flex"
            }}
          ></div>
        </ConfigProvider>
      </div>
    </div>
  );
}
